export const server = "https://shopo-back-end.vercel.app/api/v2";


